export const licitaciones = [
  {
        "anio" : "2026",
        "licitacionesLista" : [
            {
                "nombre" : "PIBEH-LP-01-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-01/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-01/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-01/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-01/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-01/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-02-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-02/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-02/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-02/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-02/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-02/Fallo.pdf"
                    }
                ]    
            },
              {
                "nombre" : "PIBEH-LP-03-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-03/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-03/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-03/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-03/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-03/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-04-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-04/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-04/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-04/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-04/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-04/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-05-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-05/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-05/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-05/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-05/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-05/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-06-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-06/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-06/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-06/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-06/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-06/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-07-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-07/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-07/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-07/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-07/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-07/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-08-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-08/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-08/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-08/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-08/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-08/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-09-2026",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-09/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-09/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-09/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-09/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/LP-09/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-ICTP-01-2026",
                "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-01/Bases.pdf"
           },
           {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-01/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-01/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-01/Fallo.pdf"
           }
                ]    
            },
            {
                "nombre" : "PIBEH-ICTP-02-2026",
                "contenidoLicitacion" : [
                     {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-02/Bases.pdf"
           },
           {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-02/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-02/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-02/Fallo.pdf"
           }
                ]    
            },
            {
                "nombre" : "PIBEH-ICTP-03-2026",
                "contenidoLicitacion" : [
                     {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-03/Bases.pdf"
           },
           {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-03/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-03/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-03/Fallo.pdf"
           }
                ]    
            },
            {
                "nombre" : "PIBEH-ICTP-04-2026",
                "contenidoLicitacion" : [
                     {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-04/Bases.pdf"
           },
           {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-04/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-04/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2026/ICTP-04/Fallo.pdf"
           }
                ]    
            },
         ]    
    },
    {
        "anio" : "2025",
        "licitacionesLista" : [
            {
                "nombre" : "PIBEH-LP-01-2025",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-01/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-01/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-01/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-01/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-01/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-02-2025",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-02/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-02/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-02/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-02/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-02/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-03-2025",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-03/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-03/Convocatoria.pdf"
                    },
                   {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-03/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-03/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-03/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-04-2025",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-04/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-04/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-04/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-04/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-04/Fallo.pdf"
                    }
                ]    
            },
           {
             "nombre" : "PIBEH-LP-05-2025",
            "contenidoLicitacion" : [
                {
                    "nombre" : "Bases",
                    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-05/Bases.pdf"
                },
                {
                    "nombre" : "Convocatoria",
                    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-05/Convocatoria.pdf"
                },
               {
                    "nombre" : "Junta de aclaraciones",
                    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-05/JAclaraciones.pdf"
                },
                {
                    "nombre" : "Presentación y apertura de propuestas",
                    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-05/PresentacionyApertura.pdf"
                },
                {
                    "nombre" : "Fallo",
                    "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-05/Fallo.pdf"
                }
            ]    
        },
        {
            "nombre" : "PIBEH-LP-06-2025",
           "contenidoLicitacion" : [
               {
                   "nombre" : "Bases",
                   "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-06/Bases.pdf"
               },
               {
                   "nombre" : "Convocatoria",
                   "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-06/Convocatoria.pdf"
               },
              {
                   "nombre" : "Junta de aclaraciones",
                   "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-06/JAclaraciones.pdf"
               },
               {
                   "nombre" : "Presentación y apertura de propuestas",
                   "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-06/PresentacionyApertura.pdf"
               },
               {
                   "nombre" : "Fallo",
                   "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-06/Fallo.pdf"
               }
           ]    
       },
       {
        "nombre" : "PIBEH-LP-07-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-07/Bases.pdf"
           },
           {
               "nombre" : "Convocatoria",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-07/Convocatoria.pdf"
           },
          {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-07/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-07/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-07/Fallo.pdf"
           }
       ]    
       },
       {
        "nombre" : "PIBEH-LP-08-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-08/Bases.pdf"
           },
           {
               "nombre" : "Convocatoria",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-08/Convocatoria.pdf"
           },
          {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-08/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-08/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-08/Fallo.pdf"
           }
       ]    
       },
       {
        "nombre" : "PIBEH-LP-09-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-09/Bases.pdf"
           },
           {
               "nombre" : "Convocatoria",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-09/Convocatoria.pdf"
           },
          {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-09/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-09/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-09/Fallo.pdf"
           }
       ]    
       },
       {
        "nombre" : "PIBEH-LP-10-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-10/Bases.pdf"
           },
           {
               "nombre" : "Convocatoria",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-10/Convocatoria.pdf"
           },
          {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-10/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-10/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-10/Fallo.pdf"
           }
       ]    
       },
       {
        "nombre" : "PIBEH-LP-11-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-11/Bases.pdf"
           },
           {
               "nombre" : "Convocatoria",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-11/Convocatoria.pdf"
           },
          {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-11/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-11/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-11/Fallo.pdf"
           }
       ]    
       },
       { "nombre" : "PIBEH-LP-12-2025",
        "contenidoLicitacion" : [

            {
                "nombre" : "Bases",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-12/Bases.pdf"
            },
            {
                "nombre" : "Convocatoria",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-12/Convocatoria.docx"
            },
            {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-12/JAclaraciones.pdf"
           },
           {
            "nombre" : "Presentanción y apertura de propuestas",
            "url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-12/PresentacionyApertura.pdf"
           },
           {
                 "nombre" : "Fallo",
                 "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-12/Fallo.pdf"  
           },

        ]
       },
       { "nombre" : "PIBEH-LP-13-2025",
        "contenidoLicitacion" : [

            {
                "nombre" : "Bases",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-13/Bases.pdf"
            },
            {
                "nombre" : "Convocatoria",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-13/Convocatoria.pdf"
            },
            {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-13/JAclaraciones.pdf"
           },
           {
            "nombre" : "Presentación y apertura de propuestas",
            "url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-13/PresentacionyApertura.pdf"
           },
           {
                 "nombre" : "Fallo",
                 "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-13/Fallo.pdf"  
           },

        ]
       },{ "nombre" : "PIBEH-LP-14-2025",
        "contenidoLicitacion" : [

            {
                "nombre" : "Bases",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-14/Bases.pdf"
            },
            {
                "nombre" : "Convocatoria",
                "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-14/Convocatoria.pdf"
            },
            {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-14/JAclaraciones.pdf"
           },
           {
            "nombre" : "Presentación y apertura de propuestas",
            "url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-14/PresentacionyApertura.pdf"
           },
           {
                 "nombre" : "Fallo",
                 "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/LP-14/Fallo.pdf"  
           },

        ]
       },
       
       {
        "nombre" : "PIBEH-ICTP-01-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-01/Bases.pdf"
           },
           {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-01/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-01/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-01/Fallo.pdf"
           }
       ]    
   },
   {
        "nombre" : "PIBEH-ICTP-02-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-02/Bases.pdf"
           },
           {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-02/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-02/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-02/Fallo.pdf"
           }
       ]    
   },
   {
        "nombre" : "PIBEH-ICTP-03-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-03/Bases.pdf"
           },
           {
               "nombre" : "Formatos",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-03/Formatos.rar"
           },
           {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-03/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-03/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-03/Fallo.pdf"
           }
       ]    
   },
   {
        "nombre" : "PIBEH-ICTP-04-2025",
       "contenidoLicitacion" : [
           {
               "nombre" : "Bases",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-04/Bases.pdf"
           },
           {
               "nombre" : "Formatos",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-04/Formatos.rar"
           },
           {
               "nombre" : "Junta de aclaraciones",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-04/JAclaraciones.pdf"
           },
           {
               "nombre" : "Presentación y apertura de propuestas",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-04/PresentacionyApertura.pdf"
           },
           {
               "nombre" : "Fallo",
               "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2025/ICTP-04/Fallo.pdf"
           }
       ]    
   },
        ]
    },   
    {
        "anio" : "2024",
        "licitacionesLista" : [
            {
                "nombre" : "PIBEH-LP-01-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-01/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-01/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-01/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-01/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-01/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-02-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-02/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-02/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-02/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-02/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-02/Fallo.pdf"
                    },
                    {
                        "nombre" : "Diferimiento de Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-02/DFallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-03-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-03/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-03/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-03/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-03/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-03/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-04-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-04/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-04/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-04/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-04/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-04/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-05-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-05/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-05/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-05/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-05/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-05/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-06-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-06/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-06/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-06/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-06/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-06/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-07-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-07/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-07/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-07/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-07/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-07/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-08-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-08/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-08/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-08/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-08/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-08/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-09-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-09/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-09/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-09/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-09/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-09/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-10-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-10/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-10/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-10/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-10/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-10/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-11-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-11/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-11/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-11/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-11/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-11/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-12-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-12/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-12/Convocatoria.docx"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-12/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-12/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-12/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-13-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-13/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-13/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-13/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-13/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-13/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-14-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-14/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-14/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-14/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-14/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-14/Fallo.pdf"
                    }
                ]    
            },
            {
                "nombre" : "PIBEH-LP-15-2024",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-15/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-15/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-15/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-15/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/LP-15/Fallo.pdf"
                    }
                ]    
            },
            {
                 "nombre" : "PIBEH-ICTP-01-2024",
                 "contenidoLicitacion" : [  
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-01/Bases.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-01/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-01/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-01/Fallo.pdf"
                    }
                ]
            },
            {
                 "nombre" : "PIBEH-ICTP-02-2024",
                 "contenidoLicitacion" : [  
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-02/Bases.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-02/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-02/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-02/Fallo.pdf"
                    }
                ]
            },
            {
                 "nombre" : "PIBEH-ICTP-03-2024",
                 "contenidoLicitacion" : [  
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-03/Bases.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-03/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-03/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2024/ICTP-03/Fallo.pdf"
                    }
                ]
            }
        ]
    },
    {
        "anio" : "2023",
        "licitacionesLista" : [
            {
                "nombre" : "PIBEH-LP-01-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-01-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-01-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-01-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-01-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-01-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-02-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-02-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-02-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-02-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-02-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-02-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-03-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-03-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-03-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-03-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-03-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-03-2023/Fallo.pdf"
                    }
                ]
            },
            /*{
                "nombre" : "PIBEH-LP-04-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-04-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-04-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-04-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-04-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-04-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-05-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-05-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-05-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-05-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-05-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-05-2023/Fallo.pdf"
                    }
                ]
            },*/
            {
                "nombre" : "PIBEH-LP-06-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-06-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-06-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-06-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-06-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-06-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-07-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-07-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-07-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-07-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-07-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-07-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-08-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-08-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-08-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-08-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-08-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-08-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-09-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-09-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-09-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-09-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-09-2023/PresentaciónyApertura.pdf"
                        
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-09-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-10-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-10-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-10-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-10-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-10-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-10-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-11-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-11-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-11-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-11-2023/Apertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-11-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-12-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-12-2023P/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-12-2023P/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-12-2023P/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-12-2023P/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-12-2023P/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-13-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-13-2023/Convocatoria.pdf"   
                    },
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-13-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-13-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-13-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-13-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-14-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-14-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-14-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-14-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-14-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-14-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-15-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-15-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-15-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-15-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-15-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-15-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-16-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-16-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-16-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-16-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-16-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-16-2023/Fallo.pdf"
                    },
                ]
            },
            {
                "nombre" : "PIBEH-LP-17-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-17-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-17-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-17-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-17-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-17-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-18-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-18-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-18-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-18-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-18-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-18-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-19-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-19-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-19-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-19-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-19-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-19-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-LP-20-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-20-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-20-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-20-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-20-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-LP-20-2023/Fallo.pdf"
                    }
                ]
            }
            ,
            {
                "nombre" : "PIBEH-ICTP-01-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-01-2023/Bases Invitación ICTP-04-23.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-01-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-01-2023/PresentaciónyApertura.pdf"
                    }/*,
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-01-2023/Fallo.pdf"
                    }*/
                ]
            }
            ,
            {
                "nombre" : "PIBEH-ICTP-02-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-02-2023/Bases Invitación ICTP-04-23.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-02-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-02-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-02-2023/Fallo.pdf"
                    }
                ]
            }
            /*,
            {
                "nombre" : "PIBEH-ICTP-03-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-03-2023/Bases Invitación ICTP-04-23.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-03-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-03-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-03-2023/Fallo.pdf"
                    }
                ]
            }*/
            ,
            {
                "nombre" : "PIBEH-ICTP-04-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-04-2023/Bases Invitación ICTP-04-23.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-04-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-04-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-04-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-ICTP-05-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-05-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-05-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-05-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-05-2023/Fallo.pdf"
                    }
                ]
            },
            {
                 "nombre" : "PIBEH-ICTP-06-2023",
                 "contenidoLicitacion" : [  
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-06-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-06-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-06-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-06-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-ICTP-07-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-07-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-07-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-07-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-07-2023/Fallo.pdf"
                    }
                ]
            },
            {
                "nombre" : "PIBEH-ICTP-08-2023",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-08-2023/Bases.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-08-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-08-2023/PresentacionyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2023/PIBEH-ICTP-08-2023/Fallo.pdf"
                    }
                ]
            }
        ]
    },
  /*  {
        "anio" : "2022",
        "licitacionesLista" : [
            {
                "nombre" : "PIBEH-LP-01-2022",
                "contenidoLicitacion" : [
                    {
                        "nombre" : "Bases",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2022/PIBEH-LP-01-2023/Bases PIBEH-LP-10-2023.pdf"
                    },
                    {
                        "nombre" : "Convocatoria",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2022/PIBEH-LP-01-2023/Convocatoria.pdf"
                    },
                    {
                        "nombre" : "Junta de aclaraciones",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2022/PIBEH-LP-01-2023/JAclaraciones.pdf"
                    },
                    {
                        "nombre" : "Presentación y apertura de propuestas",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2022/PIBEH-LP-01-2023/PresentaciónyApertura.pdf"
                    },
                    {
                        "nombre" : "Fallo",
                        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Licitaciones/2022/PIBEH-LP-01-2023/Fallo.pdf"
                    }
                ]
            },
            ]
    }*/
]